module.exports = __webpack_public_path__ + "static/media/familyCooking1000.11fe91ca.jpeg";